import { useEffect, useState } from "react";
import {
  Container,
  Panel,
  Form,
  SelectPicker,
  Grid,
  Col,
  Row,
  Checkbox,
  Button,
  Schema,
} from "rsuite";
import { updateIn } from "json-immut";
import { useTranslation } from "react-i18next";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import { messageTypeArr, roleTypeArr } from "../../../core/config/AppConstants";
import "./CustomerFilters.css";

export interface PropTypesInterface {
  onFileImport?: Function;
  onSetMobileLen?: Function;
}

function CustomerFileUpload({
  onFileImport,
  onSetMobileLen,
}: PropTypesInterface) {
  const selectedCompany = useSelector((state: any) => state.company);
  const [file, setFile] = useState<any>();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const initFormVal = {
    file: "",
    company_id: "",
    mobile_len: 10,
    country_code_from_mobile: 1,
  };
  const [formData, setFormData] = useState<any>(initFormVal);
  const [errors, setErrors] = useState<any>({});
  // Define the validation schema
  const { StringType } = Schema.Types;
  const model = Schema.Model({
    mobile_len: StringType()
      .isRequired(
        t("REQUIRED", {
          field: t("MOBILE_LEN").toLowerCase(),
        })
      )
      .pattern(/^\d+$/, "Mobile length must be a number") // Ensures it's a number
      .addRule((value) => {
        const num = Number(value);
        return num >= 7 && num <= 10;
      }, "Mobile length must be between 7 and 10"),
  });

  const downloadFileUrl = "/Import_Formats/Customers_import.xlsx";

  const handleCountryCodeFrom = (value: any, checked: any) => {
    let form = updateIn(
      formData,
      ["country_code_from_mobile"],
      checked ? value : 0
    );
    setFormData(form);
  };

  async function init() {
    try {
    } catch (error: any) {
      console.log("error ", error);
    }
  }
  useEffect(() => {
    init();
  }, []);

  const setImportFile = ($event: { target: { files: any } }) => {
    setFile($event.target.files[0]);
  };

  function getCompanyId() {
    let compId = 0;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (selectedCompany?.id) {
      compId = selectedCompany.id;
    }
    return compId;
  }
  async function uploadXLSX() {
    const form = new FormData();
    if (!getCompanyId()) {
      UtilityServices.showToaster({
        message: t("REQUIRED_SELECT", {
          field: t("COMPANY").toLowerCase(),
        }),
        type: messageTypeArr.error,
      });
      return;
    }
    if (!file) {
      UtilityServices.showToaster({
        message: t("REQUIRED_SELECT", {
          field: t("FILE").toLowerCase(),
        }),
        type: messageTypeArr.error,
      });
      return;
    }
    form.append("file", file, file.name);
    form.set("company_id", getCompanyId().toString());
    form.set("mobile_len", formData.mobile_len);
    form.set("country_code_from_mobile", formData.country_code_from_mobile);
    onSetMobileLen && onSetMobileLen(formData.mobile_len);
    onFileImport && onFileImport(form);
  }

  return (
    <>
      <div className="users cntry">
        <Container className="container">
          <Panel>
            <Grid fluid>
              <div className="row">
                <div className="form-flex">
                  <Form
                    formValue={formData}
                    onChange={(data: any) => {
                      let form = { ...formData, ...data };
                      setFormData(form);
                    }}
                    layout="inline"
                    model={model} // Apply the validation schema here
                    //onCheck={setErrors} // Track form errors
                  >
                    <Form.Group controlId="country_code_from_mobile">
                      <Form.ControlLabel>
                        {t("CODE")} {t("FROM")} {t("MOBILE")}
                      </Form.ControlLabel>
                      <Checkbox
                        name="country_code_from_mobile"
                        value={1}
                        onChange={handleCountryCodeFrom}
                        checked={
                          formData.country_code_from_mobile == 0 ? false : true
                        }
                      />
                    </Form.Group>
                    <Form.Group controlId="mobile_len">
                      <Form.ControlLabel>
                        {t("MOBILE")} {t("LENGTH")}
                      </Form.ControlLabel>

                      <Form.Control
                        name="mobile_len"
                        value={formData.mobile_len}
                        readOnly={true}
                      />
                      <span className="text-danger">
                        {errors["mobile_len"]}
                      </span>
                    </Form.Group>
                  </Form>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        name="file"
                        className="custom-file-input"
                        id="inputGroupFile"
                        required
                        onChange={setImportFile}
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      />
                      <Button onClick={() => uploadXLSX()}>
                        {t("UPLOAD")}
                      </Button>
                    </div>
                    <div>
                      <a
                        href={downloadFileUrl}
                        download="Customers_Import_Format.xlsx"
                        className="button"
                      >
                        {t("DOWNLOAD") + " " + t("FORMAT")}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Panel>
        </Container>
      </div>
    </>
  );
}

export default CustomerFileUpload;
